export default __webpack_public_path__ + "static/media/leftimgForm1.d67fa951.svg";